import Backdrop from 'components/backdrop';
import CTABlock from 'components/cta-block';
import CTAMap from 'components/cta-map';
import { Heading, Stack } from 'components/ui';
import { FC } from 'react';

interface LocationProps {
  locations?: Sanity.Schema.Location[];
}

const Locations: FC<LocationProps> = ({ locations }) => {
  const mappingLocation = locations?.find(
    (location) => location.name === 'Hawthorn East'
  );

  return (
    <>
      <Backdrop>
        <Stack space={{ initial: 2, large: 4, xLarge: 6 }}>
          <Heading level='h2'>Our locations</Heading>
        </Stack>
      </Backdrop>

      <Stack space={{ initial: 2, large: 4, xLarge: 6 }}>
        {mappingLocation && (
          <CTAMap location={mappingLocation} key={mappingLocation._id}>
            {/* <Link href={'/Salon-Studios-Hawthorn-East-floor-plan.pdf'} passHref>
              <Button as='a'>{'Download floor plan'}</Button>
            </Link> */}
          </CTAMap>
        )}

        <CTABlock
          content={[
            {
              title: 'Richmond',
              description: 'Coming soon',
              linkCTA: '',
              link: '',
              color: 'beige',
            },
            {
              title: 'Heidelberg',
              description: 'Coming soon',
              linkCTA: '',
              link: '',
              color: 'beige',
            },
            {
              // Client e-mailed us 'Moonie Ponds' but this is incorrectly spelt, I have updated
              // to the correct spelling.
              title: 'Moonee Ponds',
              description: 'Coming soon',
              linkCTA: '',
              link: '',
              color: 'beige',
            },
          ]}
        />
      </Stack>
    </>
  );
};

export default Locations;
